export const SYSTEM_MODULES = [
  { key: 'cloud', label: 'Cloud MQTT', roles: ['coordenador', 'professor', 'aluno'] },
  { key: 'biblioteca', label: 'Biblioteca de Arquivos', roles: ['coordenador', 'professor', 'aluno'] },
  { key: 'cursos', label: 'Cursos', roles: ['coordenador', 'professor', 'aluno'] }
];

export const hasSystemModule = (usuario, moduleKey) => {
  if (!moduleKey) return true;
  if (!usuario) return false;
  if (['admin', 'exxer'].includes(usuario.tipo_usuario)) return true;
  return Array.isArray(usuario.modulos_disponiveis) && usuario.modulos_disponiveis.includes(moduleKey);
};
